import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'highlightMatch'})

export class HighlightMatchPipe implements PipeTransform {
  transform(productName: string, search: string): string {
    let searchText = search;

    if (!productName || !searchText) {
      return productName;
    }

    // remove all special symbols
    searchText = searchText.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
    // convert all searched words to array
    const words = searchText.split( ' ');
    // regex to find ANY of multiple words or its parts - one|two|three
    const regex = new RegExp(words.join('|'), 'gi');
    return productName.replace(regex, '<strong>$&</strong>');
  }
}
